var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-upload',{attrs:{"name":"file","multiple":false,"showUploadList":false,"beforeUpload":_vm.action,"customRequest":() => {}}},[_c('div',[_c('a-button',{attrs:{"type":"round","disabled":_vm.uploading}},[_c('a-icon',{attrs:{"type":_vm.uploading ? 'loading' : 'upload'}}),_vm._v(_vm._s(_vm.uploadText)+" ")],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }